/* jshint multistr: true */
/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import axios from 'axios';

class PostPictureUpload extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            uploaded: false,
            thumbs: []
        };

        this.uploadFile = this.uploadFile.bind(this);

    }

    componentWillUnmount() {
        this.state.thumbs.map((thumb) => {
            URL.revokeObjectURL(thumb);
        });
    }

    uploadFile(acceptedFiles, rejections) {
        let formData = new FormData();

        if (rejections.length) {
            let errorMsgs = [];
            rejections.map(({ file, errors }) => {
                let errs = [];
                errors.map((e) => {
                    errs.push(e.message);
                });
                errorMsgs.push(`${file.name}\n${errs.join("\n")}`);
            });

            if (errorMsgs.length) {
                this.props.setUploadError(errorMsgs.join(" "));
            }
        }



        if (acceptedFiles.length) {
            formData.append('type', 'postMedia');
            acceptedFiles.map((file) => {
                let nextThumbs = [...this.state.thumbs];

                formData.append('media', file);

                if (file.type.match('video')) {
                    this.props.setPostAttribute('hasVideo', true);
                }

                nextThumbs.push(URL.createObjectURL(file));

                this.setState({
                    thumbs: nextThumbs
                });
            });

            this.props.setIsNetworking(true);

            axios({
                url: '/upload.php',
                method: 'POST',
                data: formData,
                headers: { "Content-type": "multipart/form-data" },
                withCredentials: true,
                responseType: 'json'
            })
            .then((response) => {
                let data = response.data;

                this.props.setIsNetworking(false);
                this.props.setPostAttribute('mb_id', data.mb_id);
                this.props.setPostAttribute('mediaThumb', data.thumb);

            })
            .catch((error) => {
                this.props.setIsNetworking(false);
                if (error.response) {
                    let errorData = error.response.data.errors || null,
                        errorMsgs = [];

                    const extractErrors = (obj) => {
                        if (Object.keys(obj).length) {
                            Object.keys(obj).map((key) => {
                                if (typeof obj[key] === 'string') {
                                    errorMsgs.push(obj[key]);
                                } else if (Object.keys(obj[key])) {
                                    extractErrors(obj[key]);
                                }
                            });
                        }
                    };

                    // session died before upload
                    if (error.response.status === 403) {
                        window.location.reload();
                        return;
                    }

                    extractErrors(errorData);

                    if (errorMsgs.length) {
                        this.props.setUploadError(errorMsgs.join(" "));
                    }
                } else if (error.message) {
                    this.props.setUploadError(error.message);
                }

                this.setState({
                    thumbs: []
                });
            });
        }
    }

    render() {
        let instructions = null;

        instructions = (
            <div className="instructions-wrapper">
                <div className="instructions">Drag file here</div>
                <div className="option">or</div>
                <div className="faux-button">select file</div>
            </div>
        );


        return (
            <div className="media-block image-drop">
                <div className="media-drop">
                    <Dropzone
                        accept={'image/jpeg, image/png, image/gif, video/mp4'}
                        maxFiles={1}
                        maxSize={15000000}
                        onDrop={this.uploadFile}>
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()} className="dropzone">
                                <input {...getInputProps()}/>
                                {(this.state.thumbs.length) ? (
                                    <div className="file-list">
                                        {this.state.thumbs.map((thumbUrl, i) => {
                                            return (
                                                <div key={`thumb-${i}`} className="thumb-wrapper">
                                                    <img className="file-thumb" src={thumbUrl}/>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : instructions}
                            </div>
                        )}
                    </Dropzone>
                </div>
            </div>
        );
    }

};

PostPictureUpload.propTypes = {
    activePost: PropTypes.number,
    setPostAttribute: PropTypes.func,
    setUploadError: PropTypes.func
};

PostPictureUpload.defaultProps = {
    activePost: 0,
    setPostAttribute: () => {},
    setUploadError: () => {}
};

export default PostPictureUpload;
